define("tmds/symbols/SimpleLineSymbol", [
	"jquery",
	"./Symbol",
	"./utils",
	"../validator"
], function($, Symbol, utils, validator) {
	"use strict";
	
	var constants = {
		STYLE_DASH: "dash",
		STYLE_DASHDOTDOT: "dashdotdot",
		STYLE_DOT: "dotted",
		STYLE_SOLID: "solid"
	};
	
	/**
	 * construct a new SimpleLineSymbol
	 * @param options {Object} option object with below structure
	 * 		{
	 * 			style: 'solid',
	 * 			color: [255,0,0,0.5],
	 * 			width: 2
	 * 		}
	 * @note all option members are optional
	 */
	var SimpleLineSymbol = function(options) {
		
		Symbol.call(this, options);
		
		/**
		 * default line symbol: solid black thin line
		 */
		this.color = [0,0,0,1];
		this.style = 'solid';
		this.width = 1;
		
		if (options != undefined) {
			if (validator.isDataObject(options)) {
				if (options.color != undefined) {
					setColor.call(this, options.color);
				}
					
				if (options.style != undefined) {
					setStyle.call(this, options.style);
				}
						
				if (options.width != undefined) {
					setWidth.call(this, options.width);
				}
			}
			else {
			 	throw new Error('Invalid options values - ' + options + ' passed');
		 	}
		}
	};
	
	/**
	 * set the line symbol color
	 * @param color {Array} [r,g,b,a]
	 * @return the symbol itself
	 */
	function setColor(color) {		
		var _color = utils.toColorArray(color);

		if (_color === false) {			
			throw new Error('Invalid color value - ' + color + ' passed');
		}
		
		this.color = _color;
		return this;
	}
	
	/**
	 * set the line symbol style
	 * @param style {String}
	 * @return the symbol itself
	 */
	function setStyle(style) {
		
		if (!validator.isValidLineStyle(style)) {
			throw new Error('Invalid line style - ' + style + ' passed');
		}
		
		this.style = style;	
		return this;
	}
	
	/**
	 * set the line symbol width
	 * @param width {Number} new line width
	 * @return the symbol itself
	 * @note width must be the number type, and greater than or equal to 0
	 */
	function setWidth(width) {
		
		if (!validator.isPositiveNumber(width)) {
			throw new Error('Invalid line width - ' + width + ' passed');
		}
		
		this.width = Number(width);
		return this;
	}
	
	/**
	 * convert SimpleLineSymbol object to JSON representation
	 */
	function toJson() {
		return {
			type: this.type,
			style: this.style,
			color: this.color,
			width: this.width
		};
	}
	
	/**
	 * define static methods
	 */
	SimpleLineSymbol.styles = function() { return constants; };
	
	// SimpleLineSymbol inherits Symbol with some extensions
	SimpleLineSymbol.prototype = $.extend(Object.create(Symbol.prototype), {		
		declaredClass: "tmds.symbols.SimpleLineSymbol",
		type: "SimpleLineSymbol",
		'setColor' : setColor,
		'setStyle' : setStyle,
		'setWidth' : setWidth,
		'toJson' : toJson
	});
	
	return SimpleLineSymbol;
});